export default function setNumberOrNumberAccessor(func,value){func(value)}